<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar usuario" : "Nuevo usuario" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card tag="article" no-body style="max-width: 760px" class="custom-card">
          <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
            <h3>
              {{ editing ? "Datos del usuario" : "Datos del nuevo usuario" }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section">
              <div>
                <h2 class="form-subtitle">Información general</h2>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="email">Correo electrónico</label>
                    <input id="email" type="text" v-model.trim="form.email" autocomplete="off"
                      placeholder="Ingresar correo electrónico" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.email.$error,
                      }" />
                    <FormError v-if="$v.form.email.$error && !$v.form.email.email"
                      message="Ingresa un correo electrónico válido" />
                  </div>
                </div>
                <!-- <div class="form-group">
                  <label for="name">Razón social *</label>
                  <input
                    id="name"
                    type="text"
                    maxlength="200"
                    v-model="form.name"
                    autocomplete="off"
                    placeholder="Ingresar razón social"
                    class="custom-form-control"
                    :class="{
                      'custom-form-control-error': $v.form.name.$error,
                    }"
                  />
                  <FormError
                    v-if="$v.form.name.$error && !$v.form.name.required"
                    message="Razón social es requerida"
                  />
                </div> -->
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="firstName">Nombres *</label>
                    <input id="firstName" type="text" v-model="form.firstName" autocomplete="off"
                      placeholder="Ingresar nombres" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.firstName.$error,
                      }" />
                    <FormError v-if="
                      $v.form.firstName.$error && !$v.form.firstName.required
                    " message="Nombres son requeridos" />
                    <FormError v-if="
                      $v.form.firstName.$error && !$v.form.firstName.required
                    " message="Nombres son requeridos" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="lastName">Apellidos *</label>
                    <input id="lastName" type="text" v-model="form.lastName" autocomplete="off"
                      placeholder="Ingresar apellidos" class="custom-form-control" />

                    <FormError v-if="
                      $v.form.lastName.$error && !$v.form.lastName.required
                    " message="Apellidos son requeridos" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="mobile">Celular</label>
                    <input id="mobile" type="text" v-model.trim="form.mobile" autocomplete="off"
                      placeholder="Ingresar celular" maxlength="9" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.mobile.$error,
                      }" />
                    <FormError v-if="$v.form.mobile.$error && !$v.form.mobile.numeric"
                      message="Celular debe ser un valor numérico" />
                    <FormError message="Ingresa un celular válido de 9 dígitos"
                      v-if="$v.form.mobile.$error && !$v.form.mobile.mobile"></FormError>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="profile">Perfil *</label>
                    <FormSelect id="profile" :items="profileTypes" v-model="form.profile" defaultOption="Elegir perfil"
                      :showError="$v.form.profile.$error" />

                    <FormError v-if="$v.form.profile.$error && !$v.form.profile.required"
                      message="Perfil es requerido" />
                  </div>
                </div>
              </div>
            </section>

            <div class="form-section">
              <div>
                <h2 class="form-subtitle">Marcas asociadas</h2>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <label for="profile">Marcas *</label>

                    <b-form-checkbox v-model="allProjectsSelected" @change="toggleAllProjects">
                      {{
                        allProjectsSelected
                          ? "Deseleccionar todos"
                          : "Seleccionar todos"
                      }}
                    </b-form-checkbox>

                    <div class="row">
                      <div class="col-md-4" v-for="o in form.businessIds" :key="o.key">
                        <b-form-checkbox v-model="o.status" class="mt-3" @change="allProjectsSelected = false">
                          {{ o.label }}
                        </b-form-checkbox>
                      </div>
                    </div>

                    <FormError v-if="$v.form.businessIds.$error" message="Debe seleccionar al menos una marca" />
                  </div>
                </div>
              </div>

              <div class="form-group-buttons text-right">
                <router-link :to="{ name: 'user-list' }" class="button button-light">
                  {{ editing ? "Volver" : "Cancelar" }}
                </router-link>
                <button class="button button-primary" type="submit">
                  Guardar
                </button>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  CustomValidators,
  FormSelect,
  FormError,
  Constants,
} from "wize-admin";

import { UsersService, BrandService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";
import { email, numeric, required } from "vuelidate/lib/validators";

export default {
  components: {
    FormSelect,
    FormError,
  },
  data() {
    return {
      profileTypes: [
        LocalConstants.ProfileTypes.SUPER_ADMINISTRATOR,
        LocalConstants.ProfileTypes.ADMINISTRATOR,
        LocalConstants.ProfileTypes.SUPERVISOR
      ],
      identifierTypes: [
        Constants.IdentifierType.DNI,
        Constants.IdentifierType.RUC,
        Constants.IdentifierType.CE,
        Constants.IdentifierType.PASAPORTE,
      ],
      allProjectsSelected: false,
      form: {
        email: null,
        firstName: null,
        lastName: null,
        mobile: null,
        profile: null,
        businessIds: [],
      },
      editing: false,
    };
  },
  validations: {
    form: {
      email: { email },
      firstName: { required },
      lastName: { required },
      mobile: { numeric, mobile: CustomValidators.mobile },
      profile: { required },
      businessIds: {
        hasActive(value) {
          return (
            Array.isArray(value) && value.some((item) => item.status === true)
          );
        },
      },
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },
  computed: {},
  methods: {
    toggleAllProjects() {
      this.form.businessIds.forEach((item) => {
        if (this.allProjectsSelected) {
          item.status = true;
        } else {
          item.status = false;
        }
      });
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        let profile = this.form.profile.replace("ROLE_", "")

        const data = {
          ...this.form,
          profile,
          businessIds: this.form.businessIds
            .filter((item) => item.status)
            .map((item) => item.key),
        };

        if (!this.editing) await UsersService.save(data);
        else await UsersService.update(this.$route.params.id, data);
        Alert.success("Se almacenó la información correctamente");
        this.load(this.$route.params.id);
        if (!this.editing) {
          this.$router.push({
            name: "user-list",
          });
          this.editing = true;
        }
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await UsersService.get(id);
        const payload = response.payload;

        let businessIds = payload.businesses.map((item) => ({
          key: item.id,
          label: item.tradeName,
          status: true,
        }));

        this.form.email = payload.email;
        this.form.firstName = payload.firstName;
        this.form.lastName = payload.lastName;
        this.form.mobile = payload.mobile;
        this.form.profile = 'ROLE_' + payload.profile;

        this.form.businessIds.forEach((item) => {
          let isTrue = businessIds.find(
            (business) => business.key === item.key
          );

          if (isTrue) {
            item.status = true;
          } else {
            item.status = false;
          }
        });

        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "form-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async getBrands() {
      try {
        this.$store.dispatch("app/loading", true);
        const params = { page: 0, size: 100, sort: 'id' };
        const data = { search: '', status: 1 };

        const response = await BrandService.list(data, params);
        this.form.businessIds = response.payload.content.map((item) => ({
          key: item.id,
          label: item.tradeName,
          status: false,
        }));
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    await this.getBrands();
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>
